export const countryPhones = [
  {
    code: '+62',
    icon: '/countries/indonesia.png'
  },
  {
    code: '+1',
    icon: '/countries/america.png'
  },
  {
    code: '+33',
    icon: '/countries/france.png'
  }
];
